import React, { useState, useEffect, useRef } from 'react'
import './page.css'
import { CiMail } from "react-icons/ci";
import { FaWhatsapp, FaPhone, FaMapMarkerAlt, FaClock, FaLinkedin, FaGithub, FaFacebook, FaInstagram, FaYoutube, FaTiktok, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { MdEmail, MdAccessTime } from "react-icons/md";
import { BiMessageDetail, BiSupport } from "react-icons/bi";
import { IoIosSend } from "react-icons/io";
import { AiOutlinePhone } from "react-icons/ai";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your form submission logic here
    console.log('Form submitted:', formData);
    // You can integrate with your backend API here
  };

  return (
    <>
      <div id="contact-us" className="bg-light">
        <section className="contact-page">
          {/* Hero Header */}
          <div className="contact-header">
            <div className="container">
              <h1>
                <CiMail />&nbsp;Get In Touch
              </h1>
              <p className='text-start px-4'>
                Have a project in mind? Let's discuss how CodeFlex can help transform your ideas into reality.
                We're here to answer your questions and start building something amazing together.
              </p>
            </div>
          </div>

          <div className="container pb-5">
            {/* Contact Methods Grid */}
            <div className="contact-methods-grid">
              <a className="contact-method-card email" href="mailto:kalana@codeflexofficial.com">
                <div className="method-icon">
                  <MdEmail />
                </div>
                <h3>Email Us</h3>
                <p>Send us an email anytime</p>
                <a href="mailto:kalana@codeflexofficial.com" className="method-link">
                  kalana@codeflexofficial.com
                </a>
              </a>

              <a className="contact-method-card whatsapp" href="https://wa.me/94712129185">
                <div className="method-icon">
                  <FaWhatsapp />
                </div>
                <h3>WhatsApp</h3>
                <p>Chat with us instantly</p>
                <a 
                  href="https://wa.me/94712129185" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="method-link"
                >
                  +94 71 21 29 185
                </a>
              </a>

              <a className="contact-method-card phone" href="tel:+94712129185">
                <div className="method-icon">
                  <FaPhone />
                </div>
                <h3>Call Us</h3>
                <p>Speak to our team directly</p>
                <a href="tel:+94712129185" className="method-link">
                  +94 71 21 29 185
                </a>
              </a>
            </div>

            {/* Main Content - Form and Info Side by Side */}
            <div className="contact-content-wrapper">
              {/* Contact Form */}
              <div className="contact-form-section text-start">
                <div className="section-title-bordered blue">
                  <h2>Send Us a Message</h2>
                </div>
                <p className="form-description">
                  Fill out the form below and we'll get back to you within 24 hours.
                </p>

                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Kalana Udara"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="kalana@example.com"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+94 71 21 29 185"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="Project Inquiry"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your project..."
                      rows="6"
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-btn">
                    <IoIosSend />&nbsp;Send Message
                  </button>
                </form>
              </div>

              {/* Contact Information Sidebar */}
              <div className="contact-info-sidebar">
                <div className="info-card location">
                  <div className="info-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <h3>Our Location</h3>
                  <p>Colombo, Sri Lanka</p>
                  <p className="info-subtitle">Serving clients worldwide</p>
                </div>

                <div className="info-card hours">
                  <div className="info-icon">
                    <FaClock /> 
                  </div>
                  <h3>Business Hours</h3>
                  <br/>
                  <div className="hours-list">
                    <div className="hours-item">
                      <span className="day">Monday - Sunday</span>
                      <span className="time">11:00 AM - 4:00 AM</span>
                    </div>
                  </div>
                  <p className="hours-note">
                    <MdAccessTime /> Emergency support available 24/7 for existing clients
                  </p>
                </div>

                <div className="info-card support">
                  <div className="info-icon">
                    <BiSupport />
                  </div>
                  <h3>Quick Response</h3>
                  <p>We typically respond to all inquiries within:</p>
                  <div className="response-time">
                    <span className="time-badge">24 Hours</span>
                  </div>
                  <p className="support-note">For urgent matters, please contact us via WhatsApp</p>
                </div>

                <div className="info-card social">
                  <h3>Connect With Us</h3>
                  <div className="social-links">
                                  <a className="social-link facebook" href='https://www.facebook.com/CodeFlexOfficial'><FaFacebook /></a>
                                  <a className="social-link instagram" href='https://www.instagram.com/codeflexofficial'><FaInstagram /></a>
                                  <a className="social-link youtube" href='https://www.youtube.com/@CodeFlexOfficial'><FaYoutube /></a>
                                  <a className="social-link tiktok" href='https://www.tiktok.com/@codeflexofficial'><FaTiktok /></a>
                                  <a className="social-link linkedin" href='https://www.linkedin.com/company/codeflexofficial/'><FaLinkedinIn /></a>
                                  <a className="social-link twitter" href='https://x.com/codeflexoficial'><FaTwitter /></a>
                  </div>
                </div>
              </div>
            </div>

            {/* Why Contact Us Section */}
            <div className="why-contact-section">
              <div className="section-title-bordered green text-start">
                <h2>Why Reach Out to CodeFlex?</h2>
              </div>
              <div className="why-contact-grid">
                <div className="why-contact-card">
                  <BiMessageDetail className="why-icon" />
                  <h4>Free Consultation</h4>
                  <p>Get expert advice on your project at no cost</p>
                </div>
                <div className="why-contact-card">
                  <AiOutlinePhone className="why-icon" />
                  <h4>Quick Response</h4>
                  <p>We respond to all inquiries within 24 hours</p>
                </div>
                <div className="why-contact-card">
                  <BiSupport className="why-icon" />
                  <h4>Dedicated Support</h4>
                  <p>Personal attention to your requirements</p>
                </div>
              </div>
            </div>

            {/* FAQ Section */}
            <div className="faq-section text-start">
              <div className="section-title-bordered purple">
                <h2>Frequently Asked Questions</h2>
              </div>
              
              <div className="faq-grid">
                <div className="faq-item">
                  <h4>How quickly can you start on my project?</h4>
                  <p>Once we finalize the requirements and receive the advance payment, we can typically start within 2-3 business days.</p>
                </div>

                <div className="faq-item">
                  <h4>Do you work with international clients?</h4>
                  <p>Yes! While based in Colombo, Sri Lanka, we serve clients worldwide with flexible communication options.</p>
                </div>

                <div className="faq-item">
                  <h4>What information should I include in my inquiry?</h4>
                  <p>Briefly describe your project goals, timeline, and any specific technologies or features you have in mind.</p>
                </div>

                <div className="faq-item">
                  <h4>Do you offer ongoing support after project completion?</h4>
                  <p>Absolutely! We provide maintenance and support packages to ensure your solution continues to perform optimally.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ContactUs;